import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Modal } from 'components/common';
import { INPUT_CLS } from 'helpers/formStyles';
import { CONFIRMATION_PHRASE } from './api';

const ApplyRatesModal = ({ show, rows, submitting, onHide, onConfirm }) => {
  const [phrase, setPhrase] = useState('');

  useEffect(() => { if (show) setPhrase(''); }, [show]);

  const released = rows.filter(r => r.released).length;
  const armed = phrase.trim() === CONFIRMATION_PHRASE && rows.length > 0;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      title="Apply exchange rates"
      footer={(
        <div className="tw-flex tw-items-center tw-justify-end tw-gap-2">
          <Button variant="secondary" onClick={onHide} disabled={submitting}>Cancel</Button>
          <Button variant="primary" onClick={onConfirm} disabled={!armed} loading={submitting}>
            Apply to {rows.length} payment plan{rows.length === 1 ? '' : 's'}
          </Button>
        </div>
      )}
    >
      <div className="tw-flex tw-flex-col tw-gap-3">
        <Alert
          type="warning"
          title={`${rows.length} payment plan(s) will get USD exchange rates`}
          message={released
            ? `${released} of them are released: their buildings' RECEIVED UP TO will be recalculated. No email is sent.`
            : 'No email is sent and nothing else changes.'}
        />
        <div>
          <label htmlFor="payment-rates-confirm" className="tw-block tw-text-[12.5px] tw-font-medium tw-text-slate-700 tw-mb-1">
            Type <span className="tw-font-mono tw-font-semibold">{CONFIRMATION_PHRASE}</span> to confirm
          </label>
          <input id="payment-rates-confirm" type="text" value={phrase} autoComplete="off"
            onChange={e => setPhrase(e.target.value)} placeholder={CONFIRMATION_PHRASE} className={INPUT_CLS} />
        </div>
      </div>
    </Modal>
  );
};

ApplyRatesModal.propTypes = {
  show: PropTypes.bool,
  rows: PropTypes.array.isRequired,
  submitting: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ApplyRatesModal;
